var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"t-vote"},[(_vm.count !== undefined)?_c('span',{staticClass:"t-vote__label"},[_vm._v(_vm._s(_vm.count))]):_vm._e(),_c('img',{staticClass:"t-vote__image",class:{
      't-vote__image--approve': this.type,
      't-vote__image--reject': !this.type,
    },attrs:{"src":_vm.imageSrc,"alt":_vm.imageAlt}})])}
var staticRenderFns = []

export { render, staticRenderFns }